/**
 * Cfakecomment Component
 * Fake comment for landing page demos - mimics actual chat message appearance
 */
'use client';
import { motion } from 'framer-motion';
import { useViewport } from '@/hooks/dom';
import { Viewport } from '@/theme/breakpoints';
import { pxToRem } from '@/theme/spacing';
import { ColorType, getColorValue } from '@/theme/colors';
import { dataEl } from '@/utils/dataEl';
import type { ReactElement } from 'react';
import { FakeCommentBubble } from './FakeCommentBubble';
import { FakeCommentHeader } from './FakeCommentHeader';
import { FakeCommentIconColumn } from './FakeCommentIconColumn';
import { FAKE_COMMENT_MESSAGE_KIND } from './cfakecommentConstants';
import type { CfakecommentProps } from './cfakecommentTypes';
export function Cfakecomment({ dataElScope, name, model, role, teamRole, message, date, colorHex, provider, animationDelay = 0, animationDuration = 0.3, className, style, bubbleRadius, }: CfakecommentProps): ReactElement {
    const { viewport } = useViewport();
    const isMobile = viewport === Viewport.Mobile;
    const shouldShowTeamRole = Boolean(teamRole && message.kind !== FAKE_COMMENT_MESSAGE_KIND.FileAction);
    const memberColor = colorHex || getColorValue(ColorType.White);
    const iconColumn = (<FakeCommentIconColumn role={role} provider={provider} memberColor={memberColor} isMobile={isMobile}/>);
    return <motion.div data-el={dataEl(dataElScope, 'Root')} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: animationDuration, delay: animationDelay, ease: [0.4, 0, 0.2, 1] }} style={{
            display: 'flex',
            gap: pxToRem(10),
            width: '100%',
            ...style,
        }} className={className}>
            {!isMobile && iconColumn}

            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(4),
            flex: 1,
            minWidth: 0,
        }}>
                <FakeCommentHeader name={name} model={model} teamRole={teamRole} iconColumn={iconColumn} shouldShowTeamRole={shouldShowTeamRole} isMobile={isMobile}/>
                <FakeCommentBubble dataElScope={dataElScope} message={message} date={date} animationDelay={animationDelay} isMobile={isMobile} bubbleRadius={bubbleRadius}/>
            </div>
        </motion.div>
        ;
}
